declare global {
    interface Window {
      dataLayer: Record<string, any>[];
    }
  }
  export const getDataLayer = () => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      return window.dataLayer;
    } else {
      return null;
    }
  };